import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d0214d2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0214d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0214d2')) {
      api.createRecord('6d0214d2', component.options)
    } else {
      api.reload('6d0214d2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6d0214d2&scoped=true", function () {
      api.rerender('6d0214d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/clearCache/index.vue"
export default component.exports